import { render, staticRenderFns } from "./BusinesDetailComponent.vue?vue&type=template&id=cde7c46c&"
import script from "./BusinesDetailComponent.vue?vue&type=script&lang=js&"
export * from "./BusinesDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports